export const blackTypeEnums = [{
  value: 'company',
  label: '企业'
}, {
  value: 'person',
  label: '个人'
}];
export const blackStatusEnums = {
  company: '企业',
  person: '个人'
};